import { isNativeApp } from './platform.js';

/**
 * Native share sheet when available; WhatsApp URL fallback otherwise.
 */
export async function shareLink({ title, text, url }) {
  const payload = {
    title: title || 'Repatikosam',
    text: text || '',
    url: url || '',
  };

  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    try {
      await navigator.share(payload);
      return true;
    } catch (err) {
      if (err?.name === 'AbortError') return false;
    }
  }

  const body = [payload.text, payload.url].filter(Boolean).join('\n\n');
  window.open(`https://wa.me/?text=${encodeURIComponent(body)}`, '_blank', 'noopener');
  return true;
}

export function sharePreferredOnNative() {
  return isNativeApp() && typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}
